import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DragDropContext } from "@hello-pangea/dnd";
import SituationPlaysTable from "./SituationPlaysTable";
import { OffensivePlaybookPlay, OffensiveSituation } from "../../../types/SchemesTypes";

interface OffenseGameplanPlaysProps {
  plays: OffensivePlaybookPlay[];
  offensiveSituations: OffensiveSituation[];
}

const OffenseGameplanPlays: React.FC<OffenseGameplanPlaysProps> = ({ plays, offensiveSituations }) => {
  // Local state for play priorities, grouped by situation id
  const [situationPlays, setSituationPlays] = useState<Record<string, OffensivePlaybookPlay[]>>({});
  console.log('situation plays', situationPlays);

  useEffect(() => {
    // Initialize state: group and sort plays by situation
    const grouped: Record<string, OffensivePlaybookPlay[]> = {};
    offensiveSituations.forEach((situation) => {
        const key = situation.id.toString();
        grouped[key] = plays
          .filter((play) => play.situation === situation.id)
      });
    setSituationPlays(grouped);
  }, [plays, offensiveSituations]);

  // Handle drag end for a specific situation
  const handleDragEnd = (result: any, situationId: string) => {
    if (!result.destination) return;
    const items = Array.from(situationPlays[situationId]);
    const [removed] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, removed);
    const updated = items;
    setSituationPlays({ ...situationPlays, [situationId]: updated });
  };

  return (
    <Box>
      {offensiveSituations.map((situation) => (
        <Accordion key={situation.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{situation.name}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DragDropContext
              onDragEnd={(result) => handleDragEnd(result, situation.id.toString())}
            >
              <SituationPlaysTable
                plays={situationPlays[situation.id.toString()] || []}
                droppableId={`droppable-${situation.id}`}
              />
            </DragDropContext>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default OffenseGameplanPlays; 